import { render, staticRenderFns } from "./Comite.vue?vue&type=template&id=4d55cb38&"
import script from "./Comite.vue?vue&type=script&lang=js&"
export * from "./Comite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports